import type { HierarchyRectangularNode } from 'd3-hierarchy';

import { nodePadding } from './node-padding.js';
import { shouldDrawLeafNode } from './should-draw-leaf-node.js';
import type { InternalTreeMapNode } from '../types/internal.js';

export const getTooltipData = (
  leafNodes: HierarchyRectangularNode<InternalTreeMapNode>[],
  clusterNodes: HierarchyRectangularNode<InternalTreeMapNode>[],
  relativePosition: { x: number; y: number },
  hasParentLabels: boolean = false,
) => {
  const nodes = hasParentLabels ? [...leafNodes, ...clusterNodes] : leafNodes;

  return nodes.find((node) => {
    const padding = nodePadding(node, hasParentLabels);
    const showLeafTooltip = shouldDrawLeafNode(node);

    if (!showLeafTooltip && hasParentLabels) {
      return null;
    }

    return (
      node.x0 - padding <= relativePosition.x &&
      node.x1 + padding >= relativePosition.x &&
      node.y0 - padding <= relativePosition.y &&
      node.y1 + padding >= relativePosition.y
    );
  });
};
